import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46d9e0da"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "row justify-content-center"
};
const _hoisted_2 = {
  class: "col-xl-12 col-lg-12 text-white"
};
const _hoisted_3 = {
  class: "",
  style: {
    "background": "linear-gradient(52.01deg, rgb(40, 20, 74) 0%, rgb(81, 42, 150) 100%)",
    "margin-bottom": "-34px",
    "padding": "25px 0 35px 0",
    "border-top-left-radius": "1rem",
    "border-top-right-radius": "1rem"
  }
};
const _hoisted_4 = {
  class: "d-flex align-items-center pl-2"
};
const _hoisted_5 = {
  class: "col-6 p-0 pl-4"
};
const _hoisted_6 = {
  class: "fw-medium fsi-14"
};
const _hoisted_7 = {
  class: "fw-bold fsi-18"
};
const _hoisted_8 = {
  class: "fw-bold fsi-18"
};
const _hoisted_9 = {
  class: "after-value-block"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "col-6 p-0 pl-4"
};
const _hoisted_13 = {
  class: "fw-medium fsi-14"
};
const _hoisted_14 = {
  class: "fw-bold fsi-18"
};
const _hoisted_15 = {
  class: "fw-bold fsi-18"
};
const _hoisted_16 = {
  class: "after-value-block"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mt-2"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "width": "100%",
    "background-color": "#504a4a"
  }
})], -1));
const _hoisted_20 = {
  class: "d-flex mt-2 pl-2"
};
const _hoisted_21 = {
  class: "col-6 p-0 pl-4"
};
const _hoisted_22 = {
  class: "fw-medium fsi-14"
};
const _hoisted_23 = {
  class: "fw-bold fsi-18"
};
const _hoisted_24 = {
  class: "fw-bold fsi-18"
};
const _hoisted_25 = {
  key: 0,
  class: "after-value-block"
};
const _hoisted_26 = {
  class: "col-6 p-0 pl-4"
};
const _hoisted_27 = {
  class: "fw-medium fsi-14"
};
const _hoisted_28 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_29 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "after-value-block"
}, null, -1));
const _hoisted_31 = {
  class: "row justify-content-center mt-2"
};
const _hoisted_32 = {
  class: "col-12"
};
const _hoisted_33 = {
  class: "rounded shadow p-4 bg-white border-radius-20",
  style: {
    "border-radius": "1rem !important"
  }
};
const _hoisted_34 = {
  class: "row"
};
const _hoisted_35 = {
  key: 0,
  class: "row"
};
const _hoisted_36 = {
  class: "col-12 mb-3"
};
const _hoisted_37 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_AfterValue = _resolveComponent("AfterValue");
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_Tip = _resolveComponent("Tip");
  const _component_SupPoolAdjust = _resolveComponent("SupPoolAdjust");
  const _component_ExitReserve = _resolveComponent("ExitReserve");
  const _component_SupPoolWithdraw = _resolveComponent("SupPoolWithdraw");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('farm.console.PositionValue')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_8, _toDisplayString($options.externalFormatFilPrice(_ctx.positionValue)), 1)])]),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_9, [!_ctx.currentLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.rightPanelType === 'Borrowing & Repayment' || _ctx.rightPanelType === 'Repayment' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.positionValue,
    "new-value": _ctx.afterPositionValue
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true), _ctx.rightPanelType === 'Withdraw From Node' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.positionValue,
    "new-value": _ctx.afterPositionValueByWithDraw
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('farm.console.EquityValue')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, _toDisplayString($options.externalFormatFilPrice(_ctx.equityValue)), 1)]),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_16, [!_ctx.currentLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.rightPanelType === 'Borrowing & Repayment' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.equityValue,
    "new-value": _ctx.afterEquityValue
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true), _ctx.rightPanelType === 'Withdraw From Node' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.equityValue,
    "new-value": _ctx.afterEquityValueByWithDraw
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])]), _hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('farm.console.DebtValue')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_24, _toDisplayString($options.externalFormatFilPrice(_ctx.debtValue, 4)), 1)])]),
    _: 1
  }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.debtValue,
    "new-value": _ctx.afterDebtValue
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('farm.console.InterestValue')), 1), _createVNode(_component_i_skeleton, {
    loading: $data.nodeInterestLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_29, _toDisplayString($options.formatWalletFilPrice($data.nodeInterestData)), 1)]),
    _: 1
  }, 8, ["loading"]), _hoisted_30])])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", {
    class: _normalizeClass(["col-12", _ctx.role === 2 && !$data.closeTip ? 'mb-3' : 'mb-4'])
  }, [_createVNode(_component_RadioBtn, {
    theme: 2,
    "tab-arr": $data.tabOptions,
    modelValue: $data.optionValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.optionValue = $event)
  }, null, 8, ["tab-arr", "modelValue"])], 2)]), _ctx.role === 2 && !$data.closeTip ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", null, [_createVNode(_component_Tip, {
    level: "warring"
  }, {
    btnGroup: _withCtx(() => [_createElementVNode("div", {
      class: "link-text-ordinary mr-2",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.learnMore && $options.learnMore(...args))
    }, _toDisplayString(_ctx.$t('farm.console.learnMore')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: _cache[2] || (_cache[2] = $event => $data.closeTip = true)
    }, _toDisplayString(_ctx.$t('farm.console.Close')), 1)]),
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('farm.console.WarningTip')
    }, null, 8, _hoisted_37)]),
    _: 1
  })])])])) : _createCommentVNode("", true), $data.optionValue === 'Borrowing & Repayment' ? (_openBlock(), _createBlock(_component_SupPoolAdjust, {
    key: 1,
    onGotoRepay: $options.gotoRepay,
    adjustType: "borrow",
    ref: "adjust",
    onUpdateInfo: $options.updateInfo,
    onApproveOperator: $options.approveOperator
  }, null, 8, ["onGotoRepay", "onUpdateInfo", "onApproveOperator"])) : _createCommentVNode("", true), $data.optionValue === 'LoanWithdrawal' ? (_openBlock(), _createBlock(_component_ExitReserve, {
    key: 2,
    onGotoRepay: $options.gotoRepay,
    onUpdateInfo: $options.updateInfo
  }, null, 8, ["onGotoRepay", "onUpdateInfo"])) : _createCommentVNode("", true), $data.optionValue === 'Withdraw From Node' ? (_openBlock(), _createBlock(_component_SupPoolWithdraw, {
    key: 3,
    onGotoRepay: $options.gotoRepay,
    onUpdateInfo: $options.updateInfo,
    onApproveOperator: $options.approveOperator
  }, null, 8, ["onGotoRepay", "onUpdateInfo", "onApproveOperator"])) : _createCommentVNode("", true), $data.optionValue === 'Repayment' ? (_openBlock(), _createBlock(_component_SupPoolAdjust, {
    key: 4,
    adjustType: "repay",
    ref: "adjust2",
    onUpdateInfo: $options.updateInfo,
    onApproveOperator: $options.approveOperator
  }, null, 8, ["onUpdateInfo", "onApproveOperator"])) : _createCommentVNode("", true)])])])]);
}